import {
  ProductInfo,
  ProductOptions,
  PrinterFeatures,
  PrinterFeaturesList,
} from './types';

export const getPrinterInfoById = (
  id: string,
  productsInfo: ProductInfo[]
): ProductInfo | undefined => productsInfo.find((printer) => printer.id === id);

export const getPrinterFeaturesById = (
  id: string,
  printersFeaturesList: { id: string; features: PrinterFeatures[] }[]
): PrinterFeatures[] | undefined =>
  printersFeaturesList.find((printer) => printer.id === id)?.features;

export const getFilteredOptions = (
  productsOptions: ProductOptions[],
  currentColumnSku: string,
  selectedArray: string[]
): ProductOptions[] =>
  productsOptions.filter(
    (printer) =>
      !selectedArray.includes(printer.value) ||
      printer.value === currentColumnSku
  );

const getPageOrder = (priorities: string[], printersNames: string[]) => {
  const remaining = printersNames.filter((name) => !priorities.includes(name));

  return [...priorities, ...remaining] as string[];
};

export const getNextColumn = (
  columns: string[],
  productsOptions: ProductOptions[],
  priorities?: string[],
  startIndex: number = 0
): string => {
  const printersNames = productsOptions.map((option) => option.value);
  const printersNamesOrder = priorities
    ? getPageOrder(priorities, printersNames)
    : printersNames;

  for (let i = 0; i < printersNamesOrder.length; i++) {
    const idx = (startIndex + i) % printersNamesOrder.length;
    if (!columns.includes(printersNamesOrder[idx])) {
      return printersNamesOrder[idx];
    }
  }
  return printersNamesOrder[0];
};

export const MAX_SCREEN_ELEMENTS = 3;
export const MIN_SCREEN_ELEMENTS_SIZE = 2;

export function getNumberOfColumns(productsOptions: ProductOptions[]) {
  const isSmall = window.matchMedia('(max-width: 991px)').matches;
  const shortOptions = productsOptions.length < MAX_SCREEN_ELEMENTS;
  return isSmall || shortOptions
    ? MIN_SCREEN_ELEMENTS_SIZE
    : MAX_SCREEN_ELEMENTS;
}

export const getCommonFeatures = (
  selectedArray: string[],
  features: PrinterFeaturesList[],
  featuresKeys: string[]
) =>
  featuresKeys.filter((key) =>
    features
      .filter((printer) => selectedArray.includes(printer.id))
      .some((printer) => printer.features.some((feature) => feature.id === key))
  );
